<template>
  <div class="main">
    <div class="header">
      <div class="header-wrapper">
        <div class="brand">
          <router-link to="/home">
            <img :src="logoUrl" alt="胖球跑步实验室" class="logo" />
            <h1>胖球跑步实验室</h1>
          </router-link>
        </div>
        <ul class="nav">
          <li><router-link to="/running-data-comparison-tools">跑步数据对比</router-link></li>
          <li><router-link to="/data-parse">跑步数据解析</router-link></li>
          <li><router-link to="/trajectory-comparison-tools">GPS轨迹对比</router-link></li>
          <li><router-link to="/guide">指南</router-link></li>
          <li><router-link to="/logs">日志</router-link></li>
        </ul>
      </div>
    </div>
    <div class="content">
      <transition name="fade" mode="out-in">
        <router-view></router-view>
      </transition>
    </div>
  </div>
</template>

<script>
export default {
  name: "MainLayout",
  data() {
    return {
      logoUrl: require('@/assets/images/logo.jpg'),  // 相对路径
    };
  }
};
</script>
<style lang="scss">
.main {width:100%; height:100%; position:relative;}
.header {
  position:fixed;
  top:0;
  left:0;
  width:100%;
  z-index:99;
  background-color: #fff;
  padding: 10px 30px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}
.header-wrapper {
  width:100%;
  max-width:$main-width;
  margin:auto;
  display: flex;
  justify-content: flex-start;
  align-items: center;
}
.brand {
  a {
    display: block;
    display: flex;
    align-items: center;
  }
  img {
    width:60px;
    height:60px;
    border-radius:50%;
    object-fit:cover;
  }
  h1 {
    margin:0 0 0 10px;
    font-size: 24px;
  }
}
.nav {
  display: flex;
  list-style: none;
  margin-left:50px;
  li {
    margin-left: 20px;
    a {
      text-decoration: none;
      color: #333;
      font-size: 16px;
      transition: color 0.3s ease;
      &:hover {
        color: $primary-color;
      }
    }
  }
}
.content {
  margin-top: 80px;
  padding:0 30px;
  height:calc(100vh - 80px);
  overflow-y:scroll;
}
.fade-enter-active, .fade-leave-active {
  transition: opacity 0.3s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active in <2.1.8 */ {
  opacity: 0;
}

 @media screen and (max-width: 768px) {
  .header {padding:5px 15px;}
  .header-wrapper {justify-content: space-between;}
  .brand img {width:40px; height:40px;}
  .brand h1 {display:none;}
  .nav {margin:0;}
  .nav li {margin:0 10px 0 0;}
  .nav li a {font-size:14px;}
  .content {margin-top:50px; height:calc(100vh - 50px); padding:0;}
}
</style>
